import { posts } from '~/static/helpCenter.json';

export default {
  methods: {
    supportLink(post = null) {
      let link = 'en-us';
      const currentLanguage = window.$nuxt.$i18n.i18next.language;
      if (['fr', 'ja', 'es', 'tr', 'th', 'de', 'it'].includes(currentLanguage)) {
        link = currentLanguage;
      } else if (currentLanguage?.startsWith('zh')) {
        link = 'zh-tw';
      }

      if (post !== null) {
        const { localizedLinks } = posts.find((p) => p.post === post);
        const localizedLink = localizedLinks.find(({ locale }) => locale === currentLanguage);
        const englishlink = localizedLinks.find(({ locale }) => locale === 'en');
        link = localizedLink?.link ? localizedLink?.link : englishlink?.link;
      }
      return `https://support.ocus.com/hc/${link}`;
    },
    goToHelpCenter() {
      window.open(this.supportLink(), '_blank');
    },
  },
};
